import { createPinia, type Pinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import { instanceCachingFactory, registry, singleton } from 'tsyringe'
import type { App } from 'vue'
import { CORE_INITIALIZER } from '../CoreSymbol'
import type { Initializer } from './Initializer'

/**
 * 仅仅将pinia初始化并app.use 
 */
@singleton()
@registry([{
  token: CORE_INITIALIZER,
  useFactory: instanceCachingFactory<Initializer>(c => c.resolve(StoreInitializer))
}])
export class StoreInitializer implements Initializer {
  store: Pinia
  constructor() {
    this.store = createPinia()
  }

  start(app: App<Element>): void {
    this.store.use(piniaPluginPersist)
    app.use(this.store)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  started(app: App<Element>): void {
    //
  }
}
